import {downloadFile} from "../data/dashboard_api";

export const handleFileDownload = (URL,fileName,downloadType='application/pdf') => {
    if(URL.startsWith('https://storage.googleapis.com')){
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = URL;
        a.download = fileName;
        a.click();
        return true;
    }
    else {
        return downloadFile(URL).then((response)=>{
            if(response.status === 200){
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                let blob = new Blob([response.data],{type:downloadType});
                const downloadUrl = window.URL.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(downloadUrl);
                return true;
            }
            else {
                return false;
            }
        })
    }
};


// WEBPACK FOOTER //
// ./src/utils/download_file.js